module.exports = __webpack_public_path__ + "img/weixinzixun.0f53cae7.png";